import React from 'react';
import PropTypes from 'prop-types';

import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import {
  BUTTON_THEME_BLUE_GREYCLIFF,
  BUTTON_THEME_GREEN_ADOBE,
  BUTTON_THEME_GRAY_GREYCLIFF,
} from 'client/components/ButtonDeprecated';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import { formatPhoneNumber } from 'common/formatters';

const SrUtilitySetupContactProviderModal = ({
  iconURL,
  iconBgColor,
  providerURL,
  providerName,
  providerPhoneNumber,
  onClickProvider,
  onClose,
  isTenantRemoved,
  onMarkAsTenantRemoved,
}) => {
  const redirectToProviderSite = () => {
    global.window.open(providerURL, '_blank');
    onClickProvider();
  };

  const callToProviderPhone = () => {
    global.window.open(`tel:${providerPhoneNumber}`);
  };

  return (
    <SrSimpleMessageModal
      onClose={onClose}
      contentContainerClassName="utilityProviderContact"
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      maxWidth="375"
      iconUrl={iconURL}
      iconBgColor={iconBgColor}
      headline={
        <SrBox>
          <SrText font="greycliff" weight="800" fontSize="23px" lineHeight="33px">
            Sign up for {providerName}
          </SrText>
        </SrBox>
      }
      underline
      message={
        <SrBox>
          <SrText font="greycliff" fontSize="16px" lineHeight="25px" fontWeight="600">
            Some utility companies let you sign up on their website. We also provide you with their
            customer service number just in case!
          </SrText>
        </SrBox>
      }
      multiButtons={[
        {
          buttonText: 'Sign up on website →',
          onButtonClick: redirectToProviderSite,
          buttonTheme: BUTTON_THEME_BLUE_GREYCLIFF,
        },
        {
          buttonText: `${formatPhoneNumber(providerPhoneNumber)}`,
          onButtonClick: callToProviderPhone,
          buttonTheme: BUTTON_THEME_GREEN_ADOBE,
        },
        {
          buttonText: 'Cancel',
          onButtonClick: onClose,
          buttonTheme: BUTTON_THEME_GRAY_GREYCLIFF,
        },
      ]}
      showSubLabelDecoration={false}
      subLabelText={
        !onMarkAsTenantRemoved ? null : (
          <SrText
            font="greycliff"
            color={isTenantRemoved ? 'green' : 'orange300'}
            size="16"
            weight="600"
            cursor="pointer"
            onClick={onMarkAsTenantRemoved}
          >
            {isTenantRemoved
              ? 'Whoops, this provider does service this address. Add it back now →'
              : 'I know this provider does not service this address. Remove it now →'}
          </SrText>
        )
      }
    />
  );
};

SrUtilitySetupContactProviderModal.propTypes = {
  iconURL: PropTypes.string.isRequired,
  providerURL: PropTypes.string.isRequired,
  providerName: PropTypes.string.isRequired,
  providerPhoneNumber: PropTypes.string.isRequired,
  isTenantRemoved: PropTypes.bool,
  onMarkAsTenantRemoved: PropTypes.func,
};

SrUtilitySetupContactProviderModal.displayName = 'SrUtilitySetupContactProviderModal';

export default SrUtilitySetupContactProviderModal;
